module.exports = "<div class=\"loader\">\n  <div class=\"spin\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/loader/loader.component.html
// module id = ./src/app/components/loader/loader.component.html
// module chunks = main